






























































































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class App extends Vue {

  showTop = false;
  menuShow = false;
  menuOpen = false;
  created(): void {
    console.log('created')
    window.addEventListener('scroll', () => {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      this.showTop = top > 200;
    })
  }

  scrollTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleMenu(): void {
    if (this.menuShow) {
      this.close();
    } else {
      this.open();
    }
  }

  open(): void {
    this.menuShow = true
    setTimeout(() => {
      this.menuOpen = true
    }, 10);
  }
  close(): void {
    this.menuOpen = false;
    setTimeout(() => {
      this.menuShow = false;
    }, 500);
  }
}
